import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import {
    ClientManagerInstanceToken,
    ClientManagerInterface,
    DateUtilities,
    OtherTaskNotificationModel,
} from '@evorait/pace-core';
import { faChevronDown, faChevronUp, faBox, faCircle, faDownload } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'pace-other-tasks-expandable-row',
    templateUrl: './other-tasks-expandable-row.component.html',
    styleUrls: ['./other-tasks-expandable-row.component.scss'],
})
export class OtherTasksExpandableRowComponent implements OnInit {
    @Input({ required: true }) public task: OtherTaskNotificationModel;
    @Input() public isCustomerTab: boolean;

    @Output()
    public getTask = new EventEmitter<OtherTaskNotificationModel>();

    public readonly dateFormat: string;
    public readonly dateTimeFormat: string;
    public readonly faChevronDown = faChevronDown;
    public readonly faChevronUp = faChevronUp;
    public isCollapsed = true;
    public readonly faBox = faBox;
    public readonly faCircle = faCircle;
    public readonly faDownload = faDownload;
    public formattedPlannedDate: string;
    public formattedDeadlineDate: string | undefined;
    public firstColumnValue = 'equidescr';
    public constructor(@Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface) {
        this.dateFormat = this.clientManager.getDateFormat();
        this.dateTimeFormat = this.clientManager.getDateTimeFormat();
    }
    public taskEstimatedTime = '';

    public ngOnInit(): void {
        this.formattedPlannedDate = DateUtilities.formatDate(this.task.plannedDate);
        this.formattedDeadlineDate = this.task.getDeadline();
        this.firstColumnValue = this.isCustomerTab
            ? this.task.equidescr
            : `${this.task.notificationNo} (${this.task.taskNo})`;
        this.taskEstimatedTime = this.task.getEstimatedTime();
    }

    public getTaskClickHandler(task: OtherTaskNotificationModel): void {
        this.getTask.emit(task);
    }
}
